import { createContext, useContext, useLayoutEffect, type ReactNode } from 'react';

// Строка аккаунта (язык, баланс, аватар) в ряду с заголовком страницы — так у
// бренда с layout.header = 'in-content' (макет telecom). Строку собирает
// MainLayout (она про кабинет, а не про экран), а ставит её шапка страницы:
// через контекст, чтобы shared/ui не тянул компонент из app/layout.
//
// Шапка «забирает» строку (claim): пока на экране есть PageHeader, MainLayout
// свою отдельную строку над контентом не рисует. Экран без шапки (загрузка и
// ошибка тикета) строку не теряет — её рисует MainLayout, как раньше.
export type PageHeaderAccountValue = {
  slot: ReactNode;
  // Возвращает отмену — её и зовёт cleanup эффекта.
  claim: () => () => void;
};

export const PageHeaderAccountContext = createContext<PageHeaderAccountValue | null>(null);

// null — строки у бренда нет (или шапка вне MainLayout, как в тестах).
export const usePageHeaderAccount = (): ReactNode => {
  const value = useContext(PageHeaderAccountContext);
  // useLayoutEffect: MainLayout убирает свою строку до отрисовки, без кадра с
  // двумя строками сразу.
  useLayoutEffect(() => value?.claim(), [value]);
  return value?.slot ?? null;
};
